import actions from './actions';

const initState = {
    category   : {},
    loading : false,
    errorMessage: null,
    subCategoryUpdated: false,
    message: null,
    alert: null
};

export default function createOrUpdateCategoryReducer(state = initState, action) {
    switch (action.type) {
        case actions.CREATE_OR_UPDATE_CATEGORY_REQUESTED:
            return {
                ...state,
                category   : {},
                subCategoryUpdated: false,
                loading : true
            };
        case actions.CREATE_OR_UPDATE_CATEGORY_SUCCEEDED:

            return {
                ...state,
                category   : action.category,
                subCategoryUpdated: true,
                loading    : false
            };
        case actions.CREATE_OR_UPDATE_CATEGORY_FAILED:
            return {
                ...state,
                loading : false,
                errorMessage: action.error.message,
                message: action.error.message,
                status: action.error.status,
            };
        case actions.CLEAR_ALERT_MESSAGE:
            return {
                ...state,
                message: null,
                status: null
            };
        default:
            return state;
    }
}
